export enum TransactionStatusEnum {
  FAILURE = "FAILURE",
  SUCCESS = "SUCCESS",
  CLOSED  = "CLOSED",
  WAIT = "WAIT"
}


